import React from "react";
import { makeStyles } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

// Faixa "N mensagens não lidas" do WhatsApp Web: atravessa a conversa de ponta a ponta,
// logo antes da primeira mensagem que o atendente ainda não viu.
const useStyles = makeStyles((theme) => {
  const isDark = theme.palette.type === "dark";
  const band = isDark ? "rgba(11,20,26,0.55)" : "rgba(255,255,255,0.55)";
  return {
    band: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      flex: "none",
      margin: "10px 0 6px",
      padding: "6px 0",
      // A faixa vai de ponta a ponta da conversa: a sombra estende a cor para os lados (sombra
      // não cria rolagem horizontal) e o recorte a limita à altura da faixa.
      backgroundColor: band,
      boxShadow: `0 0 0 100vmax ${band}`,
      clipPath: "inset(0 -100vmax)",
    },
    pill: {
      position: "relative",
      padding: "5px 14px",
      borderRadius: 16,
      backgroundColor: isDark ? "#182229" : "#ffffff",
      color: isDark ? "#8696a0" : "#54656f",
      boxShadow: "0 1px 0.5px rgba(11,20,26,0.13)",
      fontSize: 12.5,
      fontWeight: 500,
      lineHeight: "18px",
      textAlign: "center",
      whiteSpace: "normal",
    },
  };
});

// Onde entra a faixa: antes da N-ésima mensagem recebida, contando do fim. Se há mais não
// lidas do que mensagens carregadas, fica antes da primeira carregada.
export const findFirstUnreadId = (messages, count) => {
  if (!count || count < 1 || !Array.isArray(messages) || messages.length === 0) return null;
  let remaining = count;
  let candidate = null;
  for (let i = messages.length - 1; i >= 0; i--) {
    const m = messages[i];
    if (m.fromMe || m.isPrivate || m.mediaType === "call_log" || m.mediaType === "reactionMessage") continue;
    candidate = m.id;
    remaining -= 1;
    if (remaining === 0) return candidate;
  }
  // nenhuma recebida na página (só enviadas): não há o que marcar
  if (candidate === null) return null;
  // mais não lidas do que mensagens carregadas: antes da primeira que vira bolha (linha de
  // reação não é desenhada, então não serve de âncora)
  const first = messages.find((m) => m.mediaType !== "reactionMessage");
  return first ? first.id : null;
};

const UnreadDivider = React.forwardRef(({ count }, ref) => {
  const classes = useStyles();
  return (
    <div ref={ref} className={classes.band} role="separator" data-unread-divider="true">
      <span className={classes.pill}>{i18n.t("conversation.unread", { count })}</span>
    </div>
  );
});

export default UnreadDivider;
